import type React from 'react';
import { useCallback } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import './ServiceLayout.css';
import './EverfieldEnergy.css';

export default function EverfieldDC(): React.JSX.Element {
  const onIntersect = useCallback((entry: IntersectionObserverEntry) => {
    entry.target.classList.add('ee-content--visible');
  }, []);
  const contentRef = useIntersectionObserver<HTMLElement>(onIntersect, { threshold: 0.1 });

  return (
    <div className="service-page">
      <Navbar />

      {/* ── Hero ── */}
      <section
        className="service-page__hero ee-hero"
        aria-labelledby="dc-heading"
        style={{ '--service-bg': 'url(/FactoryPhoto.webp)' } as React.CSSProperties}
      >
        <div className="service-page__overlay" />
        <div className="service-page__content">
          <p className="service-page__label">Our Services</p>
          <h1 id="dc-heading" className="service-page__heading">Everfield DC</h1>
        </div>
      </section>

      {/* ── Content ── */}
      <section className="ee-content" aria-labelledby="dc-content-heading" ref={contentRef}>
        <h2 id="dc-content-heading" className="ee-content__heading">
          Development · Delivery · Digital
        </h2>
        <p className="ee-content__body">
          Developing and delivers a 1GW sovereign data centre platform rollout,
          leveraging Everfield Energy Hub sites and strategic renewable energy partner locations.
          Enabling sovereign AI, cloud and high-performance compute infrastructure on Australian soil.
        </p>
      </section>

      <Footer />
    </div>
  );
}
